import type { definitions } from '@luxuryescapes/contract-svc-promo';

export const CONDITION_APPLY_TYPES = ['NONE', 'MUST-INCLUDE', 'MUST-ONLY-INCLUDE', 'MUST-EXCLUDE'] as const;
export type ConditionApplyType = (typeof CONDITION_APPLY_TYPES)[number];

export const VOUCHER_CONDITION_TYPES: ReadonlyArray<definitions['VoucherConditionV1']['condition_type']> = [
  'ITEM-DESTINATION-VALIDATION-V2',
  'LOYALTY-OFFER-TYPE-VALIDATION',
  'ITEM-MARGIN-VALIDATION',
  'OFFER-ID-VALIDATION',
  'ARRIVAL-AIRPORT-CODE-VALIDATION',
  'ITEM-PROVIDER-VALIDATION',
  'ORIGIN-AIRPORT-CODE-VALIDATION',
  'NUMBER-OF-CHILDREN-VALIDATION-V2',
  'NUMBER-OF-PEOPLE-VALIDATION-V2',
  'NUMBER-OF-ADULTS-VALIDATION-V2',
  'SUBSCRIBER-TIER-VALIDATION',
] as const;

export const voucherConditionTypes = VOUCHER_CONDITION_TYPES;
export const defaultConditionApplyTypes = CONDITION_APPLY_TYPES;
